import { render, staticRenderFns } from "./VmRichTextEditor.vue?vue&type=template&id=f4d6d95c&scoped=true"
import script from "./VmRichTextEditor.vue?vue&type=script&lang=js"
export * from "./VmRichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./VmRichTextEditor.vue?vue&type=style&index=0&id=f4d6d95c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d6d95c",
  null
  
)

export default component.exports